<template>
    <div v-if="useCoupons">
        <h2>{{ $t('eventRegistration.payment.redeemCoupon') }}</h2>
        <AddCoupon
            v-if="getInvoiceTotal - getCouponTotal > 0"
            @new-coupon="addNewToRedeemCoupon" />
        <div class="coupons-grid mt-3">
            <div
                v-for="(couponToRedeem, index) in couponsToRedeem"
                :key="couponToRedeem.couponId"
                class="card p-3 m-0">
                <CouponToRedeem
                    :coupons="couponsToRedeem"
                    :index="index"
                    :already-redeemed-amount="alreadyRedeemedAmount"
                    :invoice-total="getInvoiceTotal"
                    @remove="removeCouponToRedeem(index)" />
            </div>
        </div>
        <div
            v-if="Array.isArray(redeemedCoupons) && redeemedCoupons.length"
            class="mt-3">
            <h3>{{ $t('eventRegistration.payment.redeemedCoupons') }}</h3>
            <div class="coupons-grid">
                <div
                    v-for="redeemedCoupon in redeemedCoupons"
                    :key="redeemedCoupon.redeemId"
                    class="card p-3 m-0">
                    <RedeemedCoupon :redeemed-coupon="redeemedCoupon" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";
import registrationPaymentMixin from "@/mixins/registration/registrationPaymentMixin";
import AddCoupon from "@/components/pages/registration/payment/AddCoupon";
import CouponToRedeem from "@/components/pages/registration/payment/CouponToRedeem";
import RedeemedCoupon from "@/components/pages/registration/payment/RedeemedCoupons";

export default {
    name: "Coupons",
    components: {RedeemedCoupon, CouponToRedeem, AddCoupon},
    mixins: [registrationPriceMixin, registrationPaymentMixin],
    computed: {
        useCoupons() {
            //Always use coupons if already coupons redeemed
            if (Array.isArray(this.redeemedCoupons) && this.redeemedCoupons.length) return true;

            if (!this.eventData.useCoupons) return false

            return this.getInvoiceTotal > 0;

        },
        alreadyRedeemedAmount() {
            let amount = 0
            if (!Array.isArray(this.redeemedCoupons)) return amount
            this.redeemedCoupons.forEach((coupon) => amount += coupon.redeemedAmount)
            return amount
        }
    },
    methods: {
        addNewToRedeemCoupon(coupon) {
            const couponsToRedeem = this.$cloneDeep(this.couponsToRedeem)
            if (!couponsToRedeem.find((couponToRedeem) => couponToRedeem.couponId === coupon.couponId))
                couponsToRedeem.push(coupon)
            this.couponsToRedeem = couponsToRedeem
        },
        removeCouponToRedeem(index) {
            const couponsToRedeem = this.$cloneDeep(this.couponsToRedeem)
            couponsToRedeem.splice(index, 1)
            this.couponsToRedeem = couponsToRedeem
        }
    }
}
</script>

<style lang="scss" scoped>
@use "sass:map";

.coupons-grid {
    display: grid;
    gap: map.get($spacers, 2);
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    grid-auto-rows: minmax(150px, auto);

    @include media-breakpoint-down(xs) {
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    }
}
</style>
